export const i18n = {
  pt: {
    counter: {
      activities: 'Anos de Actividade',
      clients: 'Clientes',
      countries: 'Países',
      employees: 'Colaboradores'
    },
    solutions: {
      ourcompanies: 'Empresas integrantes',
      bus: `
        Agência de comunicação integrada (360º) que faz de cada projecto uma viagem apaixonada pelo mundo das Marcas. Ao volante tem uma equipa experiente, pronta a conduzir todas as Marcas a novos destinos, tendo já desenvolvido projectos em mais de 15 países.
      `,
      superbrands: `
        Uma organização internacional independente, presente em 85 países, que se dedica à identificação e promoção das Marcas de Excelência que actuam em cada mercado.
      `,
      real: `
        Prestadora de serviços imobiliários, oferece um conjunto de serviços integrados, que incluem consultoria e mediação em operações de venda e arrendamento de imóveis, de promoção, de investimento imobiliário, apoio na gestão de imóveis, na gestão de projeto e serviços de avaliação, consultoria e research.      `,
      consulting: `
        Especialista em consultoria de negócio, distingue-se por uma atitude positiva e assertiva da sua actuação e na implementação de soluções.
      `
    },
    about: {
      description: `
      <p>Zenki 前期  decorre da língua japonesa e representa o "momento inicial".
      Deriva também da junção de duas palavras japonesas:
      </p>
      <ul>
        <li>ZEN - Melhoria e sabedoria</li>
        <li>KI - Energia Vital</li>
      </ul>
      <p>A Zenki assume-se assim como o ponto de partida, a energia vital para uma melhoria contínua, envolvendo este princípio em todos os projectos em que se envolve.</p>
      `,
      short_history: 'ENERGIA VITAL DE MUDANÇA',
      focus_title: 'Alta Qualidade<br /> Experiências de Mercado',
      focus_market: '"O foco na energização e monitorização permanente das mudanças é um factor decisivo na constante evolução dos diferentes negócios."'
    },
    carousel: {
      first: 'A mudança é a energia vital <br /> das organizações.'
    },
    contact: {
      name: 'Nome *',
      phone: 'Telefone (Opcional) ',
      email: 'E-mail *',
      message: 'Mensagem *',
      options: `<option>Service you’re looking for?</option>
      <option>Business Services</option>
      <option>Consumer Product</option>
      <option>Financial Services</option>
      <option>Software Research</option>`,
      submit: 'Enviar',
      modal_title_success: 'E-mail enviado',
      modal_text_success: 'A sua menagem foi enviada com sucesso.',
      modal_title_error: 'Preencha todos os campos!',
      modal_text_error: 'Preencha todos os campos para efectuar o contacto.',
      modal_ok: 'Está bem'
    },
    menu: {
      home: 'Página Inicial',
      companies: 'Empresas',
      about: 'Sobre nós',
      our_team: 'Equipa',
      contact: 'Contacte-nos'
    },
    shared: {
      open: 'Ver Website',
      openPTVersion: 'flag-portugal',
      openAOVersion: 'flag-angola',
      showMap: 'Ver no mapa'
    },
    team: {
      rui_vargas: `
        <i>Life isn't about finding yourself, it is about creating yourself</i>

        Licenciado em Matemática Aplicada à Economia e Gestão e com mais de 20 anos de experiência na área financeira.
        Iniciou-se na prestação de serviços de contabilidade e evoluiu para uma carreira na área financeira, onde desempenhou as funções de controller e gestor financeiro em várias empresas.
        Co-fundador do Zenki Group onde exerce as funções de Administrador e CFO, funções que acumula com a gestão de projetos de consultoria de negócio sob a marca Zenki Consultants.
      `,
      pedro_vaz: `
        <i>Não importa o que temos, mas o que fazemos com o que temos.</i>

        Licenciado em Comunicação Empresarial, com uma pós-graduação em Comunicação e Cultura e um MBA em Gestão, tem ampla experiência em Gestão e Marketing, inicia a carreira na CP - Comboios de Portugal, onde colabora 12 anos entre a comunicação e o marketing. Lidera a BUS desde 2006, sendo ainda responsável pelo projecto SUPERBRANDS em Portugal e Angola. É ainda docente universitário, nas áreas de estratégia e comunicação.`,
      goncalo_rodrigues: `
        <i>It's all about networking</i>

        Licenciado em Comunicação Empresarial com uma pós-graduação em Gestão de Marketing pelo Instituto Superior de Economia e Gestão, tem-se dedicado desde 2005 à gestão do grupo Zenki, como co-founder e CEO, assumindo um papel preponderante na dinamização do negócio e identificação de oportunidades em diferentes geografias.
      `,
      diogo_rodrigues: `
        <i>Nós somos o que fazemos repetidamente, e assim a excelência não é um feito, mas sim um hábito.</i>

        Licenciado em Economia e pós-graduado em E-Business, tem 20 anos de experiência em consultoria de gestão e estratégia, imobiliário e gestão de empresas. 
        Foi consultor em diversos projectos no sectores público, saúde, banca, telcos, energia e justiça.
        É sócio e administrador do Zenki Group e Managing Partner da Zenki Real Estate, prestador de serviços imobiliários integrados que pertence à rede de afiliados da CBRE.`
    },
    address: {
      pt: `
        <h4>PORTUGAL</h4>
        <ul>
          <li>Telefone: +351 214 261 450</li>
          <li>Morada: R. Cintura do Porto de Lisboa - Rocha Conde de Óbidos, Ed. 104 1350-352 Lisboa</li>
        </ul>
     `,
      ao: `
        <h4>ANGOLA</h4>
        <p>Telefone: +244 929 433 941</p>
        <p>Morada: R. Comandante Stona, Nº 278 Alvalade - Luanda</p>
      `
    }
  },
  en: {
    counter: {
      activities: 'Years of Activity',
      clients: 'Clients',
      countries: 'Countries',
      employees: 'Employees'
    },
    solutions: {
      ourcompanies: 'Partner companies',
      bus: `
        Integrated advertising agency (360º) assuming each project as passionate ride. With an experienced team, with relevant backgroung in nacional and internacional networks, it is ready for new destinations, having drawn projects in more than 15 different countries.
      `,
      superbrands: `
        A Global Organisation responsible for distinguinshing the strongest and most valuable brands in the world, present in more than 85 countries.`,
      real: `
        Full-service real estate provider, offers a range of integrated services, including advisory in sale and lease transactions, development, investment management, property management, project management, valuation, strategic consulting and research.
      `,
      consulting: `
        Management and consulting firm, specialized in business consulting, has a positive and assertive attitude in finding the best solutions for clients.
      `
    },
    about: {
      description: `
      <p>
      Zenki 前期 is derived from Japanese and represents the "initial moment".
      It also derives from the junction of two Japanese words:
      </p>
      <ul>
        <li>ZEN - Improvement and wisdom</li>
        <li>KI - Vital Energy</li>
      </ul>

      <p>Zenki is the starting point, the vital energy for continuous improvement, involving this principle in all the projects in which it is involved.</p>
      `,
      short_history: 'VITAL ENERGY OF CHANGE',
      focus_title: 'High-Quality<br /> Market Experinces ',
      focus_market: '"The focus on permanent energization and monitoring of changes is a decisive factor in the constant evolution in the different businesses."'
    },
    carousel: {
      first: 'Change is the vital energy <br /> for businesses.'
    },
    contact: {
      name: 'Name *',
      phone: 'Phone (Optional)',
      email: 'Email *',
      options: `<option>Service you’re looking for?</option>
      <option>Business Services</option>
      <option>Consumer Product</option>
      <option>Financial Services</option>
      <option>Software Research</option>`,
      message: 'Message *',
      submit: 'Submit',
      modal_title_success: 'Email sent',
      modal_text_success: 'Your message was sent successfully.',
      modal_title_error: 'Fill in all the fields!',
      modal_text_error: 'Fill in all the fields to make the contact.',
      modal_ok: 'Ok'
    },
    menu: {
      home: 'Home',
      companies: 'Companies',
      about: 'About US',
      our_team: 'Our Team',
      contact: 'Contact US'
    },
    shared: {
      open: 'Visit Website',
      openPTVersion: 'Portugal',
      openAOVersion: 'Angola',
      showMap: 'See on map'
    },
    team: {
      rui_vargas: `
        <i>Life isn't about finding yourself, it is about creating yourself</i>

        Graduated in Mathematics Applied to Economics and Management, has over 20 years of experience in the Financial area.
        Started his career as an accountant, assuming several roles as controller and finacial manager in several companies.
        Co-founder of Zenki Group, is actually Board Member and CFO, leading also business consultancy projects for Zenki Consultants.
      `,
      pedro_vaz: `
        <b><i>More important than the assets you have, is what you do with them.</i></b>
        
        Graduated in PR and Corporate Communication, has an MBA and a wide experience in Management, Marketing and Communication. 
        Started his career at CP - Portuguese Railways as PR and Marketing Manager, leading several key strategic projects for 12 years. 
        Since 2006 leads BUS' operation, as well as the Superbrands Project, in both Portugal and Angola. 
        As an university lecturer, teaches strategic planning, marketing and communication. 
        Is a co-founder of Zenki Group, Partner and Board Member.
      `,
      goncalo_rodrigues: `
        <i>It's all about networking</i>
        
        Graduated in Corporate Communication, with a Master in Marketing Management  from ISEG (Lisbon), has been commited since 2005 in managing Zenki Group, as co-founder and CEO, being responsible for growing business opportunities in several areas and countries.
      `,
      diogo_rodrigues: `
        <i>We are what we repeatedly do. Excellence, then, is not an act, but an habit.</i>

        Graduated on Economics and Post-Graduate in E-Business, has over 20 years of experience in management and strategic consulting, real estate and business management. 
        Has worked as consultant on several projects and industries, such as Infrastructure, Healthcare, Financial Services, Telecom, Energy, Government and Public Sector.
        Is a Zenki Group partner and board member and Zenki Real Estate Managing Partner.`
    },
    address: {
      pt: `
      <h4>PORTUGAL</h4>
      <ul>
        <li>Phone: +351 214 261 450</li>
        <li>Adress: R. Cintura do Porto de Lisboa - Rocha Conde de Óbidos, Ed. 104 1350-352 Lisboa</li>
      </ul>
      `,
      ao: `
      <h4>ANGOLA</h4>
      <p>Phone: +244 929 433 941</p>
      <p>Adress: R. Comandante Stona, Nº 278 Alvalade - Luanda</p>
     `
    }
  }
}
